import React from 'react';

import StatusWithTooltip from 'components/StatusWithTooltip/StatusWithTooltip';
import useDomain, { DomainState } from '../hooks/useDomain';
import Spinner from 'components/loader/Spinner';
import { NButton } from '@innersource-nn/novoui-react';
import AwsStatuses from 'components/StatusWithTooltip/AwsStatuses';
import { useModal } from 'hooks/useModal';

type Props = {
    environmentUri: string;
    domainStatus?: DomainState;
    domainExists: boolean;
};

export default function DomainStatus({
    environmentUri,
    domainStatus,
    domainExists,
}: Props) {
    const { openSageMakerDomain } = useModal();
    const { deleteDomain, deleteLoading } = useDomain(environmentUri);
    const { progress } = AwsStatuses[domainStatus?.status || ''] || {};

    return (
        <div className={domainExists ? 'pb-16 border-b border-slate-200' : ''}>
            {!domainStatus && <Spinner />}
            {domainExists && domainStatus && (
                <div className="w-full flex justify-between items-center text-true-blue">
                    <div>
                        <b>Domain status</b>
                        <StatusWithTooltip
                            size="default"
                            content={domainStatus.status}
                        />
                    </div>
                    <div className="flex gap-8">
                        <NButton
                            disabled={progress || !environmentUri}
                            variant="outline"
                            square
                            size="sm"
                            onClick={() =>
                                openSageMakerDomain({
                                    environmentUri,
                                    domainExists,
                                })
                            }
                        >
                            Update Domain
                        </NButton>
                        <NButton
                            disabled={progress}
                            className="outline-red-button"
                            square
                            size="sm"
                            onClick={deleteDomain}
                            isLoading={deleteLoading}
                        >
                            Delete Domain
                        </NButton>
                    </div>
                </div>
            )}
        </div>
    );
}
